module.exports = __webpack_public_path__ + "static/media/screen-facebook-altyor.701a5404.png";